import { render, staticRenderFns } from "./LcPlug.vue?vue&type=template&id=04c586a1"
import script from "./LcPlug.vue?vue&type=script&lang=js"
export * from "./LcPlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports